<template>
    <div class="animated fadeIn" id="help__page">
        <div class="row">
            <div class="col-12 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="card-block col-md-5 col-lg-12">
                            <loading v-if="loadingSidebar" message="Загружаем меню помощи..."></loading>
                            <div v-else v-html="sidebar.content"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class=" col-12 col-lg-9">
                <div class="card">
                    <div class="card-block">
                        <loading v-if="loadingDocument" message="Загружаем страницу помоши..."></loading>
                        <div v-else v-html="document.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import marked from 'marked'
  import getDocumentQuery from './../gql/queries/getDocument.graphql'

  export default {
    computed: {
      compiledSidebarMarkdown: function () {
        return marked(this.sideBarContent, {sanitize: true})
      },
      ...mapState({
        currentUser: state => state.globalStore.user
      })
    },
    watch: {
      '$route': 'loadData'
    },
    data () {
      return {
        loadingSidebar: false,
        loadingDocument: false,
        sidebar: '',
        document: '',
        documentUri: 'README'
      }
    },
    name: 'profile',
    components: {
      //
    },
    methods: {
      loadData (to, from) {
        if (to.params[0]) {
          this.documentUri = to.params[0]
        } else {
          this.documentUri = 'README'
        }
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      isSameDomain (path) {
        return path.indexOf(location.host) !== -1
      },
      getPath (path) {
        let l = document.createElement('a')
        l.href = path
        return l.pathname
      }
    },
    apollo: {
      sidebar: {
        query: getDocumentQuery,
        variables: {
          uri: '_sidebar'
        },
        watchLoading (isLoading, countModifier) {
          this.loadingSidebar = isLoading
        },
        update: (data) => {
          return data.document
        }
      },
      document: {
        query: getDocumentQuery,
        variables () {
          return {
            uri: this.documentUri
          }
        },
        watchLoading (isLoading, countModifier) {
          this.loadingDocument = isLoading
        },
        update: (data) => {
          return data.document
        }
      }
    },
    created () {
      if (this.$route.params[0]) {
        this.documentUri = this.$route.params[0]
      }
    },
    mounted () {
      document.getElementById('help__page').addEventListener('click', event => {
        let target = event.target
        while (target && target.tagName !== 'A') {
          target = target.parentNode
        }
        event.preventDefault()
        if (target && target.href && this.isSameDomain(target.href)) {
          event.preventDefault()
          this.$router.push(this.getPath(target.href))
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Help.vue?3f8ff650